module.exports = __webpack_public_path__ + "assets/147bd5b460f359f93f70d0276dac8383.svg";